/**
 * El reloj del visitante: cómo se lee del navegador y cómo se descompone una
 * duración para pintarla.
 *
 * Vive aparte del cálculo del recorrido porque es lo único del módulo que toca
 * el entorno (zona horaria del dispositivo). El resto es aritmética pura.
 */

/** Días / horas / minutos / segundos de una duración en ms. */
export interface CountdownParts {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export function splitDuration(ms: number): CountdownParts {
  const total = Math.max(0, Math.floor(ms / 1000))
  return {
    days: Math.floor(total / 86_400),
    hours: Math.floor((total % 86_400) / 3_600),
    minutes: Math.floor((total % 3_600) / 60),
    seconds: total % 60,
  }
}

/**
 * Desfase UTC del visitante **en Nochebuena**, en horas, tal y como lo declara
 * su navegador. Se pregunta por el 24 de diciembre y no por hoy a propósito: en
 * Madrid `getTimezoneOffset()` dice +2 en julio y +1 en diciembre, y quien
 * consulta la página en verano merece ver la estimación de la noche correcta.
 * No se pide la ubicación: la zona horaria ya la publica el navegador.
 */
export function decemberUtcOffsetHours(year: number): number {
  return -new Date(Date.UTC(year, 11, 24, 12, 0, 0)).getTimezoneOffset() / 60
}

/** Nombre IANA de la zona del visitante, si el navegador lo expone. */
export function resolveTimeZoneName(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null
  } catch {
    return null
  }
}
